<template>
  <footer class="footer">
    <div class="container-fluid">
      <ul class="nav">
        <li class="nav-item">
          <a
            href="https://sorseurope.eu"
            target="_blank"
            rel="noopener"
            class="nav-link"
          >
            Hoptone
          </a>
        </li>
      </ul>
      <div class="copyright">
        &copy; {{ year }}, made with <i class="fal fa-heart"></i> by
        <a href="https://qanyon.com" target="_blank">Qanyon</a>
        for a better web.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
